function isAggregateResource(resourceRecord) {
  if (!resourceRecord) return false;
  if (resourceRecord['@class'] === 'Aggregate') return true;
  if (typeof resourceRecord['@id'] === 'string' && resourceRecord['@id'].toLowerCase().indexOf('/aggregate/') >= 0) {
    return true;
  }
  return false;
}

module.exports = function isAggregatePoint(record) {
  if (!record) return false;
  var pointRecord = record.in && typeof record.in === 'object' ? record.in : record;
  if (!pointRecord || typeof pointRecord !== 'object') return false;

  if (isAggregateResource(pointRecord.resource)) {
    return true;
  }

  if (Array.isArray(pointRecord.out_Source)) {
    for (var idx = 0; idx < pointRecord.out_Source.length; idx += 1) {
      var sourceEdge = pointRecord.out_Source[idx];
      if (sourceEdge && sourceEdge.in && isAggregateResource(sourceEdge.in)) {
        return true;
      }
    }
  }

  return false;
};
